import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { findAllParent, findMenuItem } from 'helpers';
import MenuItem from './MenuItem';
import MenuItemWithChildren from './MenuItemWithChildren';

import {
    type MenuItemType,
    PROFILE as MENU_ITEMS_PROFILE,
    ATIVE as MENU_ITEMS,
    DESATIVE as MENU_ITEMS_DISABLED,
    TAXCLAIMANT as MENU_ITEMS_TAX_CLAIMANT,
    CLIENT as MENU_ITEMS_CLIENT,
    ADMIN as MENU_ITEMS_ADMIN,
} from 'data/menu-user';

import useAuth from 'global/Auth/use';
import { RelationTypeEnum as RelationType } from 'api/Tools';

const AppMenu: React.FC = () => {

    const location = useLocation();
    const authData = useAuth(state => state.data);
    const superAdminView = useAuth(state => state.superAdminView);

    const menuItemsMaster = useMemo<MenuItemType[][]>(() => {
        if (!authData) return [];

        if (authData.isAdmin && superAdminView) {
            return [MENU_ITEMS_ADMIN];
        }

        const groups: MenuItemType[][] = [];

        if (authData.relationType === undefined) {
            groups.push(MENU_ITEMS_PROFILE);
        } else if (authData.relationType === RelationType.Owner || authData.relationType === RelationType.Employee) {
            groups.push(MENU_ITEMS, MENU_ITEMS_DISABLED);
        } else if (authData.relationType === RelationType.TaxClaimant) {
            groups.push(MENU_ITEMS_TAX_CLAIMANT);
        } else if (authData.relationType === RelationType.Client) {
            groups.push(MENU_ITEMS_CLIENT);
        }

        return groups;
    }, [authData, superAdminView]);

    const menuRef = useRef<HTMLUListElement>(null);

    const [activeMenuItems, setActiveMenuItems] = useState<Array<string>>([]);

            // * toggle the menus
        const toggleMenu = (menuItem: MenuItemType, show: boolean) => {
        const allMenuItems = menuItemsMaster.flat();

        if (show) {
            setActiveMenuItems([menuItem.key, ...findAllParent(allMenuItems, menuItem)]);
            return;
        }

        // ao fechar: remove este menu (e descendentes) do activeMenuItems
        const keysToRemove = new Set<string>();
        const collectKeys = (mi: MenuItemType) => {
            keysToRemove.add(mi.key);
            (mi.children || []).forEach(collectKeys);
        };
        collectKeys(menuItem);

        setActiveMenuItems((prev) => prev.filter((k) => !keysToRemove.has(k)));
        };

    // activate the menuitems

    const activeMenu = useCallback(() => {
        const allMenuItems = menuItemsMaster.flat();
        const div = document.getElementById('main-side-menu');
        let matchingMenuItem = null;

        if (div) {
            let items: HTMLCollectionOf<HTMLAnchorElement> = div.getElementsByClassName(
                'side-nav-link-ref'
            ) as HTMLCollectionOf<HTMLAnchorElement>;
            for (let i = 0; i < items.length; ++i) {
                if (items[i].getAttribute('data-ignore-active') === 'true') continue;
                if (location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }

            if (matchingMenuItem) {
                const mid = matchingMenuItem.getAttribute('data-menu-key');
                const activeMt = findMenuItem(allMenuItems, mid!);
                if (activeMt) {
                    setActiveMenuItems([activeMt['key'], ...findAllParent(allMenuItems, activeMt)]);
                }
            }
        }
    }, [location.pathname, menuItemsMaster]);

    useEffect(() => {
        activeMenu();
    }, [activeMenu]);
    

    return (<>
        <ul className="side-nav" ref={menuRef} id="main-side-menu">
            
            {menuItemsMaster.map((menuItems, groupIndex) => {
                
                return(<React.Fragment key={groupIndex.toString()}>
                        {groupIndex > 0 && (<>
                                <hr style={{
                                    border: 'none',
                                    borderTop: '1px solid #dee2e6',
                                    margin: '12px 16px',
                                    opacity: 0.5
                                }} />
                        </>)}
                        {menuItems.map((item, index) => (
                            <React.Fragment key={index.toString()}>
                                {item.isTitle ? (
                                    <li className="side-nav-title side-nav-item">
                                        {item.label}
                                    </li>
                                ) : (
                                    <>
                                        {item.children ? (
                                            <MenuItemWithChildren
                                                item={item}
                                                toggleMenu={toggleMenu}
                                                subMenuClassNames="side-nav-second-level"
                                                activeMenuItems={activeMenuItems}
                                                linkClassName="side-nav-link"
                                            />
                                        ) : (
                                            <MenuItem
                                                item={item}
                                                linkClassName="side-nav-link"
                                                className={activeMenuItems.includes(item.key) ? 'menuitem-active' : ''}
                                            />
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </React.Fragment>)
            })}
        </ul>
    </>);
};

export default AppMenu;
